import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { sysConfig } from "./../../sysConfig";

@Component({
    selector: 'app-user-filter',
    templateUrl: './user-filter.component.html',
    styleUrls: ['./user-filter.component.css'],
    standalone: false
})
export class UserFilterComponent implements OnInit {
  @Input() timesheetMode: 'day' | 'user' | 'period' = 'day';
  @Input() isApplicationUsage: boolean = false;
  @Input() isWebsiteUsage: boolean = false;
  sysConfig = sysConfig
  @Output() toggleChange = new EventEmitter<{ isApplicationUsage: boolean, isWebsiteUsage: boolean }>();
  @Output() export = new EventEmitter<void>();

  ngOnInit() {
    // Keep incoming state; breakdown is optional (none/app/website)
  }

  toggleUsageType(event: any) {
    // Toggle between App-wise (off) and Website-wise (on)
    this.isWebsiteUsage = event.checked;
    this.isApplicationUsage = !event.checked;
    this.emitToggleChange();
  }

  setAppWise() {
    if (this.timesheetMode === 'period') {
      return;
    }
    // If App is already selected, turn it OFF to allow "none" state
    if (this.isApplicationUsage) {
      this.isApplicationUsage = false;
    } else {
      // Turn App ON and Website OFF
      this.isApplicationUsage = true;
      this.isWebsiteUsage = false;
    }
    this.emitToggleChange();
  }

  setWebsiteWise() {
    if (this.timesheetMode === 'period') {
      return;
    }
    // If Website is already selected, turn it OFF to allow "none" state
    if (this.isWebsiteUsage) {
      this.isWebsiteUsage = false;
    } else {
      // Turn Website ON and App OFF
      this.isWebsiteUsage = true;
      this.isApplicationUsage = false;
    }
    this.emitToggleChange();
  }

  emitToggleChange() {
    this.toggleChange.emit({
      isApplicationUsage: this.isApplicationUsage,
      isWebsiteUsage: this.isWebsiteUsage
    });
  }

  exportData() {
    this.export.emit();
  }
}
